import React from "react";
import { useState } from "react";
import { TextField as TextFieldMaterial, InputAdornment, IconButton } from "@mui/material";
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const TextField = ({ label, type="text", value, onChange, error=false, helperErrorText="", multiline=false, 
  rows=1, fullWidth=false, icon=false, showPasswordToggle=false, onClick=null, isDisabled=false }) => {

    const [showPassword, setShowPassword] = useState(false);

    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
          event.preventDefault();
          if (onClick) onClick();
      }
    };

    const handleTogglePassword = () => {
      setShowPassword((prev) => !prev);
    }; 

    return <TextFieldMaterial 
              type={showPasswordToggle ? (showPassword ? "text" : "password") : type}
              label={label} 
              variant="outlined"
              onChange={onChange} 
              value={value} 
              error={error}
              helperText={helperErrorText}
              multiline={multiline}
              rows={rows}      
              fullWidth={fullWidth}
              onKeyDown={handleKeyDown}
              disabled={isDisabled}
              InputProps={{
                endAdornment: 
                  <InputAdornment position="end">
                    {showPasswordToggle && (
                      <IconButton onClick={handleTogglePassword} edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    )}

                    {icon && (
                      <IconButton onClick={onClick} edge="end">
                        <SendRoundedIcon sx={{ color: "rgb(85, 94, 238)" }} />
                      </IconButton>
                    )}
                  </InputAdornment>
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                  fontFamily: "Roboto, sans-serif",
                  "&.Mui-focused fieldset": {
                    borderColor: "rgb(85, 94, 238) !important",
                  },
                },          
                "& .MuiInputLabel-root": {
                 fontFamily: "Roboto, sans-serif"
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "rgb(100, 110, 245) !important",
                },                
                "& .MuiFormHelperText-root": {
                  fontFamily: "Roboto, sans-serif"
                },
              }}
            />  
  };
  
  export default TextField;
  